import { addressClient } from "@core/clients";
import useCustomLazyQuery from "../../utils/useLazyQuery";
import { Address } from "@core/types";

const useGetCustomerAddressesLazy = () => {
  return useCustomLazyQuery<Address[] | null, string>(["customer-address", "get"], async (customerId) => {
    return await addressClient.getCustomerAddresses(customerId);
  });
};

export default useGetCustomerAddressesLazy;
